import Product from 'umg-ember-backend/components/record-explorer/for/product';

<template><Product @records={{@model}} @recordType='product' /></template>
